import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Mail, CheckCircle, Eye, MousePointer, XCircle } from 'lucide-react'
import type { EmailStats, OverallEmailStats } from '../types'

interface EmailStatsCardProps {
  stats: EmailStats | OverallEmailStats
  title?: string
}

export function EmailStatsCard({ stats, title = 'Email Statistics' }: EmailStatsCardProps) {
  const openRate = stats.totalSent > 0 ? ((stats.opened / stats.totalSent) * 100).toFixed(1) : '0'
  const clickRate = stats.opened > 0 ? ((stats.clicked / stats.opened) * 100).toFixed(1) : '0'
  const deliveryRate = stats.totalSent > 0 ? ((stats.delivered / stats.totalSent) * 100).toFixed(1) : '0'

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Mail className="h-4 w-4" />
              <span className="text-xs">Sent</span>
            </div>
            <p className="text-2xl font-bold">{stats.totalSent}</p>
          </div>

          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground">
              <CheckCircle className="h-4 w-4 text-green-500" />
              <span className="text-xs">Delivered</span>
            </div>
            <p className="text-2xl font-bold">{stats.delivered}</p>
            <p className="text-xs text-muted-foreground">{deliveryRate}% rate</p>
          </div>

          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Eye className="h-4 w-4 text-purple-500" />
              <span className="text-xs">Opened</span>
            </div>
            <p className="text-2xl font-bold">{stats.opened}</p>
            <p className="text-xs text-muted-foreground">{openRate}% rate</p>
          </div>

          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground">
              <MousePointer className="h-4 w-4 text-indigo-500" />
              <span className="text-xs">Clicked</span>
            </div>
            <p className="text-2xl font-bold">{stats.clicked}</p>
            <p className="text-xs text-muted-foreground">{clickRate}% rate</p>
          </div>

          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground">
              <XCircle className="h-4 w-4 text-red-500" />
              <span className="text-xs">Bounced</span>
            </div>
            <p className="text-2xl font-bold">{stats.bounced}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
